<template>
    <div class="check-modal-mask" @click="cancel" @touchmove.prevent>
        <div class="check-modal-dialog" :style="{ width }" @click="e => e.stopPropagation()">
            <div class="check-modal-body">
                <component ref="comp" v-bind:is="{ render: message }"></component>
            </div>
            <div class="check-modal-footer">
                <div
                    v-for="(btn, i) in buttons"
                    :key="i"
                    class="check-modal-footer-item"
                    :style="btn.style"
                    @click="btn.callback"
                >
                    {{ btn.text }}
                </div>
            </div>
        </div>
    </div>
</template>

<style lang="scss" scoped>
@mixin flex-center {
    display: flex;
    justify-content: center;
    align-items: center;
}

.check-modal-mask {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    z-index: 3000;
    @include flex-center;
}

.check-modal-dialog {
    flex-shrink: 0;
    flex-grow: 0;
    border-radius: 10px;
    width: 50%;
    background-color: #ffffff;
    z-index: 3001;
}

.check-modal-body {
    padding: 15px;
    min-height: 60px;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
}

.check-modal-footer {
    border-top: 1px solid #e4e4e4;
    @include flex-center;
}

.check-modal-footer-item {
    padding: 15px;
    width: 50%;
    text-align: center;
    &:not(:first-child) {
        border-left: 1px solid #e4e4e4;
    }
}
</style>

<script>
export default {
    props: {
        width: {
            type: String,
            default: '50%'
        },
        buttons: Array,
        message: Function
    },
    methods: {
        cancel() {
            this.remove()
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/info/CheckModal.vue